import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import Blogs from "./Pages/Blogs/Blogs";
import Home from "./Pages/Home/Home/Home";
import ProjectsDetails from "./Pages/ProjectDetails/ProjectsDetails";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/projectDetails" element={<ProjectsDetails />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
